<template>
<div class="chapter">
<div class="inner_page">
<p class="left-1"><i>O dance along the silver sand</i>,</p>
<p class="left-2"><i>And beat the turtle drum</i>,</p>
<p class="left-2"><i>That youth may last for ever</i></p>
<p class="left-2"><i>And sorrow never come.</i></p>
<p class="right001"><span class="smallcaps">IAN SERRAILLIER</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frantmatter01.vue?e5c45b3c